import React, { useEffect, useState, useCallback } from "react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { onlineOrderingLinks } from "@/components/lib/SidebarLinks";
import API from "@/api/lib/api";
import useAuth from "@/hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllWebsiteSettings } from "@/redux/slice/order-ordering-slice/websiteSettingsSlice";
import Loading from "@/components/common/loading";
import { Skeleton } from "@/components/ui/skeleton";

const TemporaryDisable = () => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isDeliveryEnabled, setIsDeliveryEnabled] = useState(false);

  const websiteSettings = useSelector(
    (state) => state.onlineOrdering.websiteSettings.websiteSettings
  );
  const { getLoading } = useSelector((state) => state.onlineOrdering.websiteSettings);  

  useEffect(() => {
    if (user?.restaurant_id) {
      dispatch(fetchAllWebsiteSettings(user.restaurant_id));
    }
  }, [dispatch, user?.restaurant_id]);

  useEffect(() => {
    if (websiteSettings?.setting) {
      setIsEnabled(websiteSettings.setting.temporary_disable);
      setIsDeliveryEnabled(websiteSettings.setting.temporary_delivery_disable);
    }
  }, [websiteSettings]);

  const handleToggle = useCallback(async () => {
    if (!user?.restaurant_id) return;

    setLoading(true);
    try {
      const { data } = await API.put(
        `online-order/settings/restaurant/${user.restaurant_id}/toggle-temporary-disable`
      );

      const updatedValue = data?.data?.setting?.temporary_disable;
      setIsEnabled(updatedValue);
    } catch (error) {
      console.error("Toggle failed:", error);
    } finally {
      setLoading(false);
    }
  }, [user?.restaurant_id]);

  const handleDeliveryToggle = useCallback(async () => {
    if (!user?.restaurant_id) return;

    setLoading(true);
    try {
      const { data } = await API.put(
        `online-order/settings/restaurant/${user.restaurant_id}/toggle-temporary-delivery-disable`
      );

      const updatedValue = data?.data?.setting?.temporary_delivery_disable;
      setIsDeliveryEnabled(updatedValue);
    } catch (error) {
      console.error("Toggle failed:", error);
    } finally {
      setLoading(false);
    }
  }, [user?.restaurant_id]);

  if (getLoading) return <Loading links={onlineOrderingLinks}>
    <div className="px-4 mx-auto w-full">
      {/* Table Header */}
      <div className="px-2 mt-16">
        <Skeleton className="h-8 w-40 mb-4 col-span-1" />
        <Skeleton className="h-40 w-full col-span-1" />
      </div>
      <div className="px-2 mt-8">
        <Skeleton className="h-8 w-40 mb-4 col-span-1" />
        <Skeleton className="h-40 w-full col-span-1" />
      </div>
    </div>
  </Loading>;

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={onlineOrderingLinks} />}
      pageName={{ title: "Temporary Disable" }}
      paths={[
        // { name: "Home", path: "/home" },
        // { name: "Online Ordering", path: "/online-ordering" },
        { name: "Settings", path: "/onlineordering/settings/website-settings" },
        { name: "Temporary Disable" },
      ]}
    >
      <div className="container mt-5">
        <div>
          <p className="text-sm font-normal text-cwhite mb-2.5">Website</p>
          <div className="flex items-center justify-between bg-[#2B2D2F] p-4 rounded-md">
            <div>
              <p className="text-white text-sm font-normal">Temporary Disable</p>
              <p className="text-gray-300 text-sm font-normal mt-2">
                Temporarily disables online ordering on the website. Customers won’t be able to place orders until it’s re-enabled.
              </p>
            </div>

            <button
              onClick={handleToggle}
              disabled={loading}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                isEnabled ? "bg-green-600" : "bg-gray-500"
              } ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                  isEnabled ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        </div>
        <div className="mt-5">
          <p className="text-sm font-normal text-cwhite mb-2.5">Delivery</p>
          <div className="flex items-center justify-between bg-[#2B2D2F] p-4 rounded-md">
            <div>
              <p className="text-white text-sm font-normal">Temporary Delivery Disable</p>
              <p className="text-gray-300 text-sm font-normal mt-2">
                Temporarily disables delivery on the website. Customers won’t be able to place orders until it’s re-enabled.
              </p>
            </div>

            <button
              onClick={handleDeliveryToggle}
              disabled={loading}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                isDeliveryEnabled ? "bg-green-600" : "bg-gray-500"
              } ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                  isDeliveryEnabled ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </button>
          </div>
        </div>
      </div>
    </Layout2>
  );
};

export default TemporaryDisable;
